import { render } from "./FrontHome.vue?vue&type=template&id=04b178f2&scoped=true"
import script from "./FrontHome.vue?vue&type=script&lang=js"
export * from "./FrontHome.vue?vue&type=script&lang=js"

import "./FrontHome.vue?vue&type=style&index=0&id=04b178f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b178f2"]])

export default __exports__